import { Component, Input, Output, EventEmitter, forwardRef, AfterViewInit, OnChanges, SimpleChanges, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { InputNumberModule } from 'primeng/inputnumber';

@Component({
  selector: 'app-numberinput',
  standalone: true,
  imports: [FormsModule, InputNumberModule],
  templateUrl: './numberinput.component.html',
  styleUrl: './numberinput.component.scss',  
})

export class NumberinputComponent implements OnChanges{
  @Input() value: number | undefined = undefined;  
  @Input() mode: string = ''; 
  @Input() required: boolean = false;  
  @Input() placeholder: string = '';
  @Input() maxLength: number = 10;
  @Input() maxValue: number = 999999.99;
  @Input() customErrorMessage: string = ''; 
  @Output() valueChange: EventEmitter<number> = new EventEmitter<number>();
  touched: boolean = false;
  errorMessage: string = ''; 

  ngOnChanges(changes: SimpleChanges): void {       
    if (changes['value']) {      
      this.value = changes['value'].currentValue;      
      this.onTouched();
    }
  }
  
  validate(): void {        
    if (this.required && !this.value) {
      this.errorMessage = this.customErrorMessage || 'This field is required'; 
    } else {
      this.errorMessage = '';
    }
  }

  get isRequiredAndEmpty(): boolean {    
    return this.required && !this.value;
  }

  onFocus(): void {    
    this.touched = true;
  }

  onBlur(): void {    
    this.touched = true;
    this.validate();
  }

  onValueChange(event: any): void {        
    this.value = event.value;
    this.valueChange.emit(this.value);      
    this.validate();
  }
  
  private onTouched: () => void = () => { };
}
